import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"
import { Icon as DSIcon } from "quorumdesign"
import React from "react"
import { Link } from "react-router-dom"

const dataCy = "refresh-sheet"

const IndexHeaderCell = (props) => {
    switch (true) {
        case Boolean(props.loading):
            return (
                <Link>
                    <Tooltip label={"Loading..."}>
                        {props.isResourceTable ? (
                            <div className="index-header-icon">
                                <DSIcon icon="sync" iconFamily="far" size="sm" data-cy={dataCy} spin />
                            </div>
                        ) : (
                            <Icon name="refresh" spin data-cy={dataCy} />
                        )}
                    </Tooltip>
                </Link>
            )
        case Boolean(props.isFilteredOrSorted):
            return (
                <Link onClick={() => props.clearFilterAndSort(props.id)}>
                    <Tooltip label={"Click here to remove all filtering and sorting"}>
                        {props.isResourceTable ? (
                            <div className="index-header-icon">
                                <DSIcon icon="undo" iconFamily="fas" size="sm" data-cy={dataCy} />
                            </div>
                        ) : (
                            <Icon name={"undo"} data-cy={dataCy} />
                        )}
                    </Tooltip>
                </Link>
            )
        default:
            const dataType = DjangIO.app.models.QuorumDataType.by_value(props.dataType)
            if (dataType && !dataType.fa5_icon) {
                console.error(
                    `Please update the quorumDataType ${dataType.label} with a fa5_icon for the new Resource Tables`,
                )
            }
            return (
                <Link>
                    <Tooltip label={`Click here to refresh`}>
                        {props.isResourceTable && dataType.fa5_icon ? (
                            <div className="index-header-icon">
                                <DSIcon
                                    icon="sync"
                                    iconFamily="far"
                                    size="sm"
                                    data-cy={dataCy}
                                    onClick={props.load}
                                    style={{ cursor: "pointer" }}
                                    className="disabled"
                                    color={dataType.iconColor}
                                />
                            </div>
                        ) : (
                            <div>
                                <Icon
                                    data-cy={dataCy}
                                    onClick={props.load}
                                    name="refresh"
                                    className={"disabled"}
                                    style={{ cursor: "pointer" }}
                                />
                            </div>
                        )}
                    </Tooltip>
                </Link>
            )
    }
}

export default IndexHeaderCell
